var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListActiveAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19C17CED-7C0F-4CE5-A854-50713007E07D_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid---Expanded",
    transform: "translate(-1135.000000, -190.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(927.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_List-Alt",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.333333333 L12,0.333333333",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L9,5",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.66666667 L12,9.66666667",
    id: "Stroke-5"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListActiveAlt);
export default __webpack_public_path__ + "static/media/Icon_List_Active-Alt.52161b2bf87395c9be010524b690b85d.svg";
export { ForwardRef as ReactComponent };